import { Auth, Hub } from "aws-amplify";
import { setFederatedLoginError } from "api/ssoHelper";
import { AuthService } from "@adfenix/types";

export const getHostName = () => {
  const hostName = window.location.hostname;

  switch (hostName) {
    case "localhost":
    case "app.realforce.com":
    case "app2.adfenix.com":
    case "app.adfenix.com":
    case "app-staging.realforce.com":
      return hostName;

    default:
      return "app.adfenix.com";
  }
};

export const getLoginUrls = (idp: string | undefined) => {
  const hostName = getHostName();
  const port = hostName === "localhost" ? ":3000" : "";
  const baseLogin = `${window.location.protocol}//${hostName}${port}/login/`;

  return {
    loginUrl: idp ? `${baseLogin}?idp=${idp}` : baseLogin,
    signOutUrl: `${window.location.protocol}//${hostName}${port}/signout`
  };
};

const configAmplify = (config: AuthService.IdentityProviderPublicResponse) => {
  const { loginUrl, signOutUrl } = getLoginUrls(
    config.callbackSignInUrl.split("?idp=")[1]
  );
  const auth = {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: config.region,

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: config.userPoolId,

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: config.clientId,

      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: true,

      // authenticationFlowType: 'USER_SRP_AUTH',
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
      cookieStorage: {
        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        domain: getHostName(),
        // OPTIONAL - Cookie expiration in days
        expires: 30,
        // OPTIONAL - Cookie secure flag
        // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
        secure: process.env.REACT_APP_COGNITO_COOKIE_SECURE === "true"
      },

      // OPTIONAL - Hosted UI configuration
      oauth: {
        domain: config.customDomain,
        scope: config.scopes,
        redirectSignIn: loginUrl,
        redirectSignOut: signOutUrl,
        responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
      }
    }
  };
  Auth.configure(auth);
  if (!config.defaultProvider)
    Hub.listen("auth", data => {
      switch (data.payload.event) {
        case "signIn_failure":
          setFederatedLoginError("user federated sign in failed");
          break;
      }
    });
  return;
};

export default configAmplify;
